import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause--white",
  "use": "icon-pause--white-usage",
  "viewBox": "0 0 30 58",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 58\" id=\"icon-pause--white\"><rect width=\"10\" height=\"58\" rx=\"2\" fill=\"#fff\" /><rect x=\"20\" width=\"10\" height=\"58\" rx=\"2\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol